import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Banner.css";
import { Link } from "react-router-dom";

const slides = [
  {
    title: "Audio Streaming",
    text: "Music streaming has been a daunting task, and at VDNI, we fully understand the technical nuances required to deliver smooth and efficient audio streaming solutions.",
    button: "Explore Services",
    bgImage: "/Images/bg-1.jpg"
  },
  {
    title: "YouTube Channel Management",
    text: "VDNI fully understands the nitty-gritty involved in managing YouTube channels across all digital platforms to ensure growth, consistency, and performance.",
    button: "Explore Services",
    bgImage: "/Images/bg-2.jpg"
  },
  {
    title: "Celebrity Management",
    text: "VDNI has the expertise to manage celebrity profiles across digital platforms, boosting online presence, visibility, and brand engagement.",
    button: "Explore Services",
    bgImage: "/Images/bg-3.jpg"
  }
];

const Banner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="section banner-section-container position-relative hero_banner"
      style={{
        backgroundImage: `url(${slides[index].bgImage})`,
        transition: "background-image 1s ease-in-out"
      }}
    >
      <div className="image-overlay" />

      <Container fluid className="r-container h-100 position-relative" style={{ zIndex: 2 }}>
        <Row className="row w-100 h-100 justify-content-center align-items-center">
          <Col className="text-center">
            <div className="slider-box">
              {slides.map((item, i) => (
                <div key={i} className={`slide-item ${i === index ? "active" : ""}`}>
                  <h1 className="font-1 fw-bold lh-1 banner_h1">
                    <span className="accent-color">
                      <mark>{item.title}</mark>
                    </span>
                  </h1>

                  <p className="text-gray fs-5 mx-auto">
                    {item.text}
                  </p>

                  <div className="mt-3">
                    <Link to="/services" className="button_button__MFmXH button_color__bLscP">
                      {item.button}
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
